(($, Drupal) => {

  const id = "xencms:paragraph--price-table-v2-1";

  Drupal.behaviors[id] = {
    attach: function (context, settings) {
      function setMatchHeight() {
        const isMobile = window.innerWidth <= 767;
        for (let i = 1; i <= 30; i++) {
          const $elements = $(`.td-row-same-height-${i} .table-data--wrapper .table-child--wrapper`, context);
          if ($elements.length) {
            if (isMobile && $elements.closest('.md-show-table-v2-1').length) {
              $elements.css('height', '');
              continue;
            }
            // Find max height
            let maxHeight = 0;
            $elements.each(function () {
              const h = $(this).outerHeight();
              if (h > maxHeight) {
                maxHeight = h;
              }
            });

            // Apply max height as min-height
            $elements.css('height', maxHeight + 'px');
          }
        }

      }
      // Run on load
      setMatchHeight();

      // Run on window resize (debounced)
      let resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          setMatchHeight();
        }, 150);
      });

      $('.paragraph--price-table-v2-1 .toggle-price-tabs--wrapper', context).each(function () {
        var $wrapper = $(this).closest('.paragraph--price-table-v2-1');
        var $tabs = $(this).find('.toggle-price-tab');

        $tabs.on('click', function () {
          $tabs.removeClass('active');
          $(this).addClass('active');
          console.log($wrapper.find('.price-table-header-month'))
          console.log($wrapper.find('.price-table-header-annually'))
          console.log($(this).hasClass('toggle-price-tab-month'))
          if ($(this).hasClass('toggle-price-tab-month')) {
            $wrapper.find('.price-table-header-month').addClass('active');
            $wrapper.find('.price-table-header-annually').removeClass('active');
          } else {
            $wrapper.find('.price-table-header-annually').addClass('active');
            $wrapper.find('.price-table-header-month').removeClass('active');
          }
        });
      });
    }
  };
})(jQuery, Drupal);
